import { render, staticRenderFns } from "./BloqueFoto.vue?vue&type=template&id=b7e5325a&scoped=true&"
import script from "./BloqueFoto.vue?vue&type=script&lang=js&"
export * from "./BloqueFoto.vue?vue&type=script&lang=js&"
import style0 from "./BloqueFoto.vue?vue&type=style&index=0&id=b7e5325a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e5325a",
  null
  
)

export default component.exports